const TOKEN_COOKIE = 'latestgameplantoken';

/**
 * The `document.cookie` assignments that store the sign-in token (#1528).
 *
 * SameSite=Lax keeps the browser from attaching it to another site's form
 * posts, fetches and WebSockets, while a link into the app (an email, say)
 * still arrives with it, so the page renders signed in.
 *
 * Earlier builds wrote no Path, which scoped the cookie to the page's own
 * directory: the workspace's copy sat at /projects/{id}, and the browser sends
 * the more specific copy first. Each write also expires the current page's
 * copy, so the stale one does not outlive the update on pages still visited.
 */
export function tokenCookieWrites(token: string, page: { protocol: string; pathname: string }): string[] {
    const secure = page.protocol === 'https:' ? '; Secure' : '';
    const writes = [`${TOKEN_COOKIE}=${token}; Path=/; SameSite=Lax${secure}`];

    const legacyPath = defaultCookiePath(page.pathname);
    if (legacyPath !== '/') {
        writes.push(`${TOKEN_COOKIE}=; Path=${legacyPath}; Max-Age=0`);
    }

    return writes;
}

/** RFC 6265 §5.1.4: the path up to, not including, its last "/". */
function defaultCookiePath(pathname: string): string {
    const lastSlash = pathname.lastIndexOf('/');
    return pathname.startsWith('/') && lastSlash > 0 ? pathname.substring(0, lastSlash) : '/';
}
